










import { Vue, Component } from 'vue-property-decorator';
import AsignacionSitrack from '@/pantallas/Asignacion_sitrack/AsignacionSitrack.vue';

@Component({
  components: { AsignacionSitrack },
})
export default class AsignacionSitrackPantalla extends Vue {}
